module.exports = __webpack_public_path__ + "img/gra2.bb372afd.png";